import { Box, Button, Stack, styled } from '@ltvco/refresh-lib/theme';

export const PanelRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: theme.palette.background.paper,
  borderLeft: `1px solid ${theme.palette.divider}`,
}));

export const PanelHeader = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(3, 2.5, 2.5),
}));

export const PanelBody = styled(Box)(({ theme }) => ({
  flex: 1,
  overflowY: 'auto',
  paddingTop: theme.spacing(0.5),
}));

export const PanelFooter = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2, 2.5),
  borderTop: `1px solid ${theme.palette.divider}`,
  flexDirection: 'row',
  gap: theme.spacing(1.5),
}));

export const DateGroupContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: Math.max(Number(theme.shape.borderRadius) || 4, 8),
  margin: theme.spacing(0, 2.5, 1.5),
  overflow: 'hidden',
}));

export const DateGroupHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1.5, 2),
  cursor: 'pointer',
  backgroundColor: theme.palette.background.default,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const SectionRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(1.25, 2),
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const FooterButton = styled(Button)({
  borderRadius: '24px',
  textTransform: 'none',
  fontWeight: 'bold',
});

export const MetadataIcon = styled('span')(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.text.secondary,
  display: 'inline-flex',
  alignItems: 'center',
}));

export const ChangesList = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(2),
  paddingBottom: theme.spacing(1),
  paddingTop: 0,
  margin: 0,
}));

export const ChangeItem = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
}));
